import { Pipe, PipeTransform } from '@angular/core';
import { displayPatientAttachmentStatus } from '../../core/options/patient-attachment-status.opts';

@Pipe({ name: 'patientAttachmentStatus' })
export class PatientAttachmentStatusPipe implements PipeTransform {
  transform = displayPatientAttachmentStatus
}
